import React from 'react';
import './Summary-Swap.css';
import Helmet from "react-helmet/es/Helmet";
import FaqButtonService from "../faq-button-service/faq-button-service";
import {DateTime} from 'luxon';

class SummarySwap extends React.Component {

    constructor(props) {
        super(props);
        this.paymentFormRef = React.createRef();
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;

        this.state = {
        	guestList: '',
            showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            updateBooking: this.props.booking,
            cruiselines : [],
            charges: {
                totalWithOutInsurance: this.booking.totalWithOutInsurance,
                insuranceTotal: this.booking.insuranceTotal,
                paymentsReceived: this.booking.paymentsReceived,
                pendingPaymentTotal: this.booking.pendingPaymentTotal,
                remainingBalanceIncludingInsurance: this.booking.remainingBalanceIncludingInsurance,
                remainingBalanceExcludingInsurance: this.booking.remainingBalanceExcludingInsurance,
                nextPaymentDueDate: this.booking.nextPaymentDueDate,
                finalPaymentDate: this.booking.finalPaymentDate,
                includeInsurance: this.booking.remainingBalanceIncludingInsurance !== this.booking.remainingBalanceExcludingInsurance,
                currentAmount: 0
            },
			showPhoneNumber: this.props.booking.bookingOverview.luxuryBooking ? this.props.siteConfigData.store.luxuryPhone : this.props.siteConfigData.cruisePhone,
			updateVanityNumber: null,
			isSiteVanity: false
        }
        this.daysBeforePaymentDueDate = 0;
		this.siteZendeskID = this.getSitePropertyValue("ZENDESK_ID");

        window.dataLayer = window.dataLayer || [];
        try {
			var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else {
				console.log("off");    
			}
       
        } catch (error) {
            //swallow error
        }
    }

	replaceIfIsLuxuryBooking = () => {
		const elementsWithNums = document.querySelectorAll('.js-change-phone-number')

		let updatedCruisePhone; 
		updatedCruisePhone = this.state.updateVanityNumber;
		for (var i = 0; i < elementsWithNums.length; i++) {
		
			if (this.state.isSiteVanity) {
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone[0], this.state.showPhoneNumber)
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone[1], this.state.showPhoneNumber)
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone[2], this.state.showPhoneNumber)
				
			} else {
				updatedCruisePhone = this.props.siteConfigData.cruisePhone;
				elementsWithNums[i].innerHTML = elementsWithNums[i].innerHTML.replaceAll(updatedCruisePhone, this.state.showPhoneNumber)
			}
		}

		if (this.props.siteConfigData.store.storeCode === "CRZNW") {
			elementsWithNums[0].children[0].innerHTML = elementsWithNums[0].children[0].innerHTML.replace(this.props.siteConfigData.cruisePhone, this.state.showPhoneNumber)
		} 
		
		if (this.props.siteConfigData.store.storeCode === "RIWEB") {
			elementsWithNums[0].children[0].innerHTML = elementsWithNums[0].children[0].innerHTML.replace(this.props.siteConfigData.cruisePhone, this.state.showPhoneNumber)
			elementsWithNums[1].children[2].innerHTML = elementsWithNums[1].children[2].innerHTML.replace(this.props.siteConfigData.cruisePhone, this.state.showPhoneNumber)
		}
	}

	checkIfSiteVanity = () => {
		if (this.props.siteConfigData.store.storeCode === "CRZNW" || this.props.siteConfigData.store.storeCode === "CNCLW") {
			this.setState({
				updateVanityNumber: this.setupNumbersWithVanity("8002784737"),
				isSiteVanity: true
			})
		} else if (this.props.siteConfigData.store.storeCode === "VOWEB") {
			this.setState({
				updateVanityNumber: this.setupNumbersWithVanity("8008253633"),
				isSiteVanity: true
			})
		} else if (this.props.siteConfigData.store.storeCode === "RIWEB") {
			this.setState({
				updateVanityNumber: this.setupNumbersWithVanity("8777242628"),
				isSiteVanity: true
			})
		}
	}

	setupNumbersWithVanity = (phoneNumber) => {

		const updateNumWithOneHyphen = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3);
		const updateNumWithTwoHyphen = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3, 6) + "-" + phoneNumber.slice(6);

		const formattedPhoneNumberWith1 = '1-' + updateNumWithTwoHyphen;

	
		if (this.props.booking.bookingOverview.luxuryBooking === false) {
			this.setState({
				showPhoneNumber: formattedPhoneNumberWith1
			})
		}
		return [formattedPhoneNumberWith1, updateNumWithOneHyphen, updateNumWithTwoHyphen];

	}

    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    getFormattedDate = (dateToFormat) => {
    	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_HUGE);
    	return formattedDate;
    }
    
    /* Spinner for Ajax calls */
    ajaxSpinnerShow = () => {
    	 document.getElementById("ajaxLoadText").innerHTML = "loading";
    	 document.getElementById("ajaxShim").style.display = "block";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
    	 document.getElementById("ajaxSpinner").style.display = "block";
     }	
     
     ajaxSpinnerHide = () => {
    	 document.getElementById("ajaxSpinner").style.display = "none";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
    	 document.getElementById("ajaxShim").style.display = "none";
     }
    
    getInvoiceLink = () => {
    	let invoiceLink = "https://" + this.props.siteConfigData.domainName + "/invoiceredirect.do?bn=" + this.props.booking.bookingNumber + "&cn=" + this.props.booking.bookingSummary.guestList[0].customerNumber + "&cs=" + this.props.booking.encryptedKey + "&bp=" + this.props.booking.bookingSummary.charges.totalCost + "&bd=" + this.props.booking.bookingDate;
    	return invoiceLink;
    }
    
    getDomainLink = () => {
    	let domainLink = "https://" + this.props.siteConfigData.domainName + "/promotion/cruise-transfers.do"; 
    	return domainLink;
    }

	getNextBookingPromoLink = () => {
    	let nextBookingPromoLink = "https://" + this.props.siteConfigData.domainName + "/promotion/book-your-next-cruise.do?cid=" + this.getSitePropertyValue("CSS_CID_PROMOTION_ID");
    	return nextBookingPromoLink;
    }

	getTravelHotelLink = () => {
    	let travelHotelLink = "https://travel.bjs.com/hotels/";
    	return travelHotelLink;
    }
    
    getShoreExcursionsLink = () => {
    	let invoiceLink = "http://www.shoreexcursionsgroup.com/v/affiliate/?id=" + this.getSitePropertyValue('SHORE_EXCURSIONS_ID');
    	return invoiceLink;
    }

	getExploreDiscountedAddonLink = () => {
		let baseUrl = this.props.siteConfigData.domainName.replace(/^www\./, '');
    	let rewardsLink = "https://rewards." + baseUrl + "/dashboard/discounted-add-ons";
    	return rewardsLink;
    }
    
    getSailingLink = () => {
    	let sailingId = this.props.booking.bookingOverview.sailingId;
    	let nextSailingLink = "https://" + this.props.siteConfigData.domainName + "/b/c/sail.do?sailingId=" + sailingId;
    	return nextSailingLink;
    }

    displayBookAnotherStateroomButtton = () => {
    	let currentDate = new Date();
    	currentDate = new Date(currentDate.setHours(0, 0, 0, 0));
    	currentDate = this.formatDate(currentDate);
    	return this.getSitePropertyValue('CSS_BOOK_ANOTHER_STATEROOM_BUTTON') === 'Y' && this.props.booking.bookingOverview.sailingId !== null && this.props.booking.bookingOverview.sailingId !== 'null' && this.props.booking.bookingOverview.sailingId !== '' && this.props.booking.bookingOverview.bookableOnline === true && this.props.booking.bookingOverview.departureDate >= currentDate;
    }

    formatDate = (date) => {
    	let dd = String(date.getDate()).padStart(2, '0');
    	let mm = String(date.getMonth() + 1).padStart(2, '0');
    	let yyyy = date.getFullYear();
    	return yyyy + '-' + mm + '-' + dd;
    }

    getCruisePackingListLink = () => {
    	let regionCode = this.props.booking.bookingOverview.regionCode;
    	let destination = "";
    	switch(regionCode) {
    		case "ALSK":
    			destination = "alaska-cruise-packing-list.do";
    			break;
    		case "MECA":
    			destination = "caribbean-cruise-packing-list.do";
    			break;
    		case "CARI":
    			destination = "caribbean-cruise-packing-list.do";
    			break;
    		case "NAMR":
    			destination = "canada-new-england-cruise-packing-list.do";
    			break;
    		case "MEDT":
    			destination = "mediterranean-cruise-packing-list.do";
    			break;
    		case "EURO":
    			destination = "northern-europe-cruise-packing-list.do";
    			break;
    		default:
				break;
    	}
    	let cruisePackingListLink = "https://" + this.props.siteConfigData.domainName + "/promotion/" + destination;
    	window.open(cruisePackingListLink,'_blank', "");
    }
    
    getRedeemableBonusOffers = (booking, hash) => {
    	this.ajaxSpinnerShow();
        console.debug('Retrieve bonus offers...');
        let url = '/wthrest/customer-self-service/retrieveRedeemableBonusOffers.rs';
        let payload = {
            "bookingNumber": this.props.booking.bookingNumber
        };
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(retrieveBonusOfferResponse => retrieveBonusOfferResponse.json()).then(jsonBonusOfferResponse => {

        	if(jsonBonusOfferResponse===''||jsonBonusOfferResponse===null) {
        		this.ajaxSpinnerHide();
                let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
               	 this.props.CallTracker("Customer Self Service", "Errors", "Non-cruise booking");
               	 this.setState({
                        'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                    });
                this.setState({accessReservationBookingDisabled: false});
            } else {            
            //show new view
            	this.ajaxSpinnerHide();
            this.props.onChangeViewRedeem(this.booking, this.booking.hash, jsonBonusOfferResponse, this.state.updateBooking);
            }
        }).catch(error => {
        	this.ajaxSpinnerHide();
            this.setState({accessReservationBookingDisabled: false});
            this.setState({'showVerificationErrorMessage': true});
            let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
            //TODO  make errors more specific
            this.setState({
                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
            });
        });
    	
    }
    setConfirmationNumberStorage = () => {
    	localStorage.setItem("confirmationNumber", this.state.updateBooking.bookingNumber);
    	return '';
    }
    
    getItin = () => {
    	let itinState = false;
    	if(this.props.booking.bookingOverview.hasOwnProperty('itineraryName')){
    		if(this.props.booking.bookingOverview.itineraryName!==''&&this.props.booking.bookingOverview.itineraryName!==null&&this.props.booking.bookingOverview.itineraryName!=='null'){
    			itinState = true;
    		}
    	}
    	return itinState;
    }

    
    componentWillMount = () => {
    	this.ajaxSpinnerShow();
    	this.setConfirmationNumberStorage();
    	console.debug('getting booking in summary...');
        let url = '/wthrest/customer-self-service/getBooking.rs';
        let payload = {
            "bookingNumber": this.props.booking.bookingNumber,
            "hash": this.props.hash
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => {
        	this.ajaxSpinnerHide();
        	this.setState({updateBooking: jsonBookingResponse});
        	this.setState({booking: jsonBookingResponse});
        	localStorage.setItem('previousPayments', this.state.updateBooking.bookingSummary.charges.paymentsToDate);
        	document.getElementById("wrapper_bcss").style.display='grid';
			
			this.checkIfSiteVanity();
			if (this.props.booking.bookingOverview.luxuryBooking) {
				this.replaceIfIsLuxuryBooking();
			}
        	return jsonBookingResponse;
        	
        	
        }).catch(error => {
        	this.ajaxSpinnerHide();
        	console.log("get booking failed");
            //TODO set error
        	return null;
        });

    }

    
    componentDidMount() {
        this.checkCruiseline();
        }
        
    componentDidUpdate(prevProps, prevState) {
    if (
        this.booking !== prevProps.booking ||
        this.siteConfigData !== prevProps.siteConfigData
        ) {
            this.checkCruiseline();
            }
            }
                            
   checkCruiseline() {
    const bookingCruiseData = this.booking?.bookingOverview?.cruise;
    const siteProps = this.siteConfigData?.siteProperties || [];  
    
    if (!bookingCruiseData || !bookingCruiseData.cruiseLineId) {    
        if (this.state.cruiselines.length > 0) {
            this.setState({ cruiselines: [] });
            }
            return;
          }

   const bookingCruiseId = bookingCruiseData.cruiseLineId;

   const isMatched = siteProps.some((prop) => {
    if (prop.propertyName === "BCSS_API_CRUISELINE_IDS") {
     const values = prop.propertyValue?.split(',').map(id => id.trim());
     return values.includes(bookingCruiseId);
      }
     return false;
    });

  const apiCruiseName =
    isMatched && bookingCruiseData.cruiseLineName
      ? [bookingCruiseData.cruiseLineName]
      : [];
  const current = this.state.cruiselines;
  const hasChanged =
    apiCruiseName.length !== current.length ||
    apiCruiseName.some((name, i) => name !== current[i]);

  if (hasChanged) {
    this.setState({ cruiselines: apiCruiseName });
    }
   }

    
     render = () => {
		const apiCruisLines = this.state.cruiselines;		     
        return (
            <div className="rea-appContainer" id="mainContent" tabindex="-1">
                <Helmet>
                    <title>Customer Self Service / Summary</title>
                </Helmet> 
				<div id='cssSummaryDisembarkDate' class="wth2-disembarkDate" style={{position: 'absolute', left: '-999px'}} aria-description="disembark date">
					{this.getFormattedDate(this.state.updateBooking.bookingSummary.returnDate)}
                </div>
                <div class="wth2-css_heading">
            		<h1 class="wth2-pageTopH1" id="css_title_visible">Booking Summary</h1>
	            </div>
				{!apiCruisLines.includes(this.state.updateBooking.bookingOverview.cruise.cruiseLineName) &&
					<div class="wth2-css_tripToolsHeading">
						<a class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-css-callToBook wth2-ui-btn" href={`tel:${this.state.showPhoneNumber}`} onClick = {() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Click To Call")} }>Please call {this.state.showPhoneNumber} to make a payment or add travel Insurance.</a>
					</div>
				}
				
	            <div id="message" class="wth2-errorMessage wth2-errorMessageHeader" style={{ display: 'none'}}></div>
	            <div id="messageInvoice" class="wth2-sucessMessage" style={{ display: 'none'}}><div class="wth2-sucessMessageCont"><div class="wth2-sucessMessageHeader" id="messageInvoiceCont"></div><div id="messageInvoiceSub"></div></div></div>
	            <div id="messageInvoiceFail" class="wth2-errorMessage wth2-errorMessageHeader" style={{ display: 'none'}}><div class="wth2-sucessMessageCont wth2-sucessMessageHeader" id="messageInvoiceFailCont"></div></div>
	            		<div class="wth2-cssMainContainer">
	            			<div class="wth_css_headContainer"><span class="wth2_css_headdesc" id="css_yourCruise">Your Cruise:</span> 
		            			{this.getItin() &&
		            			<span id="css_itineraryName">{this.props.booking.bookingOverview.itineraryName}</span>
		            			}
	            			</div>
	            			<div class="wth2_css_holdContainer">
	            				<div class="wth2_lineContainer"><span class="wth2_css_headdesc" id="css_confirmationLabel">Confirmation Number:</span> <span id="css_partnerCode">{this.props.siteConfigData.partnercode}</span> - <span id="css_bookingNumber">{this.state.updateBooking.bookingNumber}</span></div>
	            				<div class="wth2_lineContainer"><span class="wth2_css_headdesc" id="css_lineShipLabel">Cruise Line and Ship:</span> <span id="css_cruiseLineName">{this.props.booking.bookingOverview.cruise.cruiseLineName}</span> - <span id="css_vesselName" class="wth2_css_italics">{this.props.booking.bookingOverview.cruise.vesselName}</span></div>
	            				{this.props.booking.bookingOverview.cruise.venRes!=='' && this.props.booking.bookingOverview.cruise.venRes!==null &&
	            					<div class="wth2_lineContainer"><span class="wth2_css_headdesc" id="css_lineVenResLabel">{this.props.booking.bookingOverview.cruise.cruiseLineName} Confirmation Number:</span> <span id="css_venRes">{this.props.booking.bookingOverview.cruise.venRes}</span></div>
	            				}
	            				<div class="wth2_lineContainer"><span class="wth2_css_headdesc"id="css_departsLabel">Departs:</span> <span id="css_departureDate">{this.getFormattedDate(this.props.booking.bookingOverview.departureDate)}</span></div>
	            				{this.props.booking.bookingOverview.bookingIncludes.length>0 &&
	            					<div class="wth2_lineContainer"><span class="wth2_css_headdesc" id="css_boookingIncludesLabel">Booking Includes:</span>{this.props.booking.bookingOverview.bookingIncludes.map((bookingInformationItem, index, arr)=>(  
            				        	<span>
	            				        	{bookingInformationItem!=='Options' && <span id={"css_bookingIncludes" + index} class="">{bookingInformationItem}{arr.length !== index - 1 && arr.length > 1 && ", "} </span>
	            				        	}
	            				        	{bookingInformationItem==='Options' && <span id={"css_bookingIncludes" + index} class="">Add Ons{arr.length !== index - 1 && arr.length > 1 && ", "} </span>
	            				        	}
            							</span>
	            			        ))}</div>
	            				}
	            			</div>
	            			<div class="wth2_css_holdContainer2">
	            			{this.props.booking.bookingOverview.guestNames.length>1 &&
	            				<div class="wth2_css_paxHead wth2_css_headdesc" id="css_guestsLabel">Guests: </div>
	            			}
	            			{this.props.booking.bookingOverview.guestNames.length===1 &&
	            				<div class="wth2_css_paxHead wth2_css_headdesc" id="css_guestLabel">Guest: </div>
	            			}
	            			<div class="wth2_css_paxContainer" id="css_guestPaxContainer">
	            				{this.props.booking.bookingOverview.guestNames.map((guest, index, arr)=>(            
	            			            <span className="wth3-css_guestListItem wth3-titleCase" id={"css_passenger" + index}>{guest.toLowerCase()}<br/></span>
	            		        ))}
	            			</div>
	            		
	            			</div>	
	            		</div>
	            	
	            	<div class="wrapper_bcss" id="wrapper_bcss" style={{display: 'none'}}>
	            		{this.getStoreAttValue('SCB') === 'Y' &&
	            		<a href='https://bit.ly/39Ojsby' target="_blank" rel="noopener noreferrer" class="wth2-css_nav_link wth2-ui-btn box_bcss a" id="css_nav_link0" onClick = {() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Schedule Call Back")} }>
	            	  		<i aria-hidden="true" class="fa fa-phone-square wth2-css_nav_icon"></i>
	            	  		<div class="wth2-css_nav_invoice">Schedule Call Back</div>
	            		</a>
	            		}
	            	 	<a href={this.getInvoiceLink()} target="_blank" rel="noopener noreferrer" class="wth2-css_nav_link wth2-ui-btn box_bcss a" id="css_nav_link1" onClick = {() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Review Your Booking Confirmation")}}>
	            	  		<i aria-hidden="true" class="fa fa-clipboard wth2-css_nav_icon"></i>
	            	  		<div class="wth2-css_nav_invoice">Review Your Booking Confirmation</div>
	            		</a>
	            		{this.state.updateBooking.bookingSummary.charges.remainingBalance!=='0.0' && this.state.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments!==0 && this.state.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments >=25 && apiCruisLines.includes(this.state.updateBooking.bookingOverview.cruise.cruiseLineName) &&
	            	  	<a href="# " class="wth2-css_nav_link wth2-ui-btn box_bcss b" id="css_nav_link2" onClick={e => {e.preventDefault(); this.props.onChangeView('paymentview', this.booking, this.booking.hash, this.state.updateBooking)} }>
	            			<i aria-hidden="true" class="fa fa-credit-card wth2-css_nav_icon"></i>
	            			<div class="wth2-css_nav_invoice">Make Safe and Secure Payments</div>
	            		</a>
	            		}

	            		{this.state.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && this.state.updateBooking.insuranceQuote.priceAmount!=='' && apiCruisLines.includes(this.state.updateBooking.bookingOverview.cruise.cruiseLineName) &&
		            		<a href="# " class="wth2-css_nav_link wth2-ui-btn box_bcss c" id="css_nav_link3" onClick={e => {e.preventDefault();this.props.onChangeView('addinsurance', this.booking, this.booking.hash, this.state.updateBooking)} }>
		            			<i aria-hidden="true" class="fa fa-umbrella wth2-css_nav_icon"></i>
		            			<div class="wth2-css_nav_invoice">Add Travel Insurance</div>
		            		</a>
	            		}            		
	            		
	            		{this.getStoreAttValue('PFB') === 'Y' && this.state.updateBooking.bookingSummary.hasRedeembableBonusOffers === 'Y' &&
	            		<a href='# ' class="wth2-css_nav_link wth2-ui-btn box_bcss a1" id="css_nav_link0a"  onClick={e => {e.preventDefault();this.getRedeemableBonusOffers(this.booking, this.booking.hash)} }>
	            	  		<i aria-hidden="true" class="fa fa-gift wth2-css_nav_icon"></i>
	            	  		<div class="wth2-css_nav_invoice">Redeem Bonus Offer</div>
	            		</a>
	            		}
	            		
	            		
	            		{this.getStoreAttValue('SHF') === 'Y' && this.getSitePropertyValue('SHORE_EXCURSIONS_ID')!==null && this.getSitePropertyValue('SHORE_EXCURSIONS_ID')!=='' &&
            				<a href={this.getShoreExcursionsLink()} class="wth2-css_nav_link wth2-ui-btn box_bcss e" id="css_nav_link5" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book Shore Excursions")}}>
            					<i aria-hidden="true" class="fa fa-anchor wth2-css_nav_icon"></i>
            					<div class="wth2-css_nav_invoice">Book Shore Excursions</div>
            				</a>
	            		}

						{this.getStoreAttValue("BMV")!=='' && this.getStoreAttValue("BMV")!==null && this.getStoreAttValue("BMV")!=='N' &&
            				<a href={this.getExploreDiscountedAddonLink()} class="wth2-css_nav_link wth2-ui-btn box_bcss e" id="css_nav_link_explore_discounted_addon" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Explore Discounted Add-ons")}}>
            					<i aria-hidden="true" class="fa fa-cart-plus wth2-css_nav_icon"></i>
            					<div class="wth2-css_nav_invoice">Explore Discounted Add-ons</div>
            				</a>
	            		}

						{/* Extra $100 button  */}
						{this.getSitePropertyValue('CSS_BUTTON_$100_OFF_NEXT_BOOKING_PROMO') === 'Y' && this.getSitePropertyValue('CSS_CID_PROMOTION_ID') !== null && this.getSitePropertyValue('CSS_CID_PROMOTION_ID') !== '' &&
            				<a href={this.getNextBookingPromoLink()} class="wth2-css_nav_link wth2-ui-btn box_bcss next_booking_promo" id="css_nav_link_next_booking_promo" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Claim $100 Off My Next Cruise")}}>
            					<i aria-hidden="true" class="fas fa-hand-holding-usd wth2-css_nav_icon"></i>
            					<div class="wth2-css_nav_invoice">Extra $100 off your next booking</div>
            				</a>
	            		}	
	            		
	            		{(this.props.booking.bookingOverview.departurePort?.includes("Seattle") || this.props.booking.bookingOverview.disembarkPort?.includes("Seattle")) && this.getSitePropertyValue('CSS_BUTTON_FOR_HOUSE_BRAND')!==null && this.getSitePropertyValue('CSS_BUTTON_FOR_HOUSE_BRAND')!=='' && this.getSitePropertyValue('CSS_BUTTON_FOR_HOUSE_BRAND')==='Y' &&
            				<a href={this.getDomainLink()} class="wth2-css_nav_link wth2-ui-btn box_bcss e" id="css_nav_link8" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book My Pier/Airport Shuttle")}}>
            					<i aria-hidden="true" class="fa fa-bus wth2-css_nav_icon"></i>
            					<div class="wth2-css_nav_invoice">Book My Pier/Airport Shuttle</div>
            				</a>
	            		}
	            		{this.getTemplatePropertyValue('BCSS_THINGS_TO_KNOW_FLAG')==='Y' && this.state.updateBooking.bookingOverview.cruise.cruiseLineName==='Carnival Cruise Line' &&       		
	            			<a class="wth2-css_nav_link wth2-ui-btn box_bcss f" id="css_nav_link6" href="# " rel="nofollow" onClick={e => {e.preventDefault();this.props.onChangeView('carnivalthings', this.booking, this.booking.hash, this.state.updateBooking)} }>
	            				<i aria-hidden="true" class="fa fa-question-circle wth2-css_nav_icon"></i>
	            				<div class="wth2-css_nav_invoice">Things To Know Before You Go</div>
	            			</a>	
	            		}
	            		
	            		{this.displayBookAnotherStateroomButtton() && 
	            			<a href={this.getSailingLink()} target="_blank" rel="noopener noreferrer" class="wth2-css_nav_link wth2-ui-btn box_bcss f" id="css_nav_link9" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Book Another Stateroom")}}>
	            				<i aria-hidden="true" class="fas fa-door-open wth2-css_nav_icon"></i>
	            				<div class="wth2-css_nav_invoice">Book Another Room On This Cruise</div>
	            			</a>
	            		}
	            		
	            		{(this.props.booking.bookingOverview.regionCode === 'MEDT' || this.props.booking.bookingOverview.regionCode === 'CARI' || this.props.booking.bookingOverview.regionCode === 'ALSK' || this.props.booking.bookingOverview.regionCode === 'MECA' || this.props.booking.bookingOverview.regionCode === 'NAMR' || this.props.booking.bookingOverview.regionCode === 'EURO') &&
	            			<a href="# " class="wth2-css_nav_link wth2-ui-btn box_bcss f" id="css_nav_link7" onClick={e => {e.preventDefault();this.getCruisePackingListLink()}}>
	            				<i aria-hidden="true" class="fa fa-list wth2-css_nav_icon"></i>
	            				<div class="wth2-css_nav_invoice">Cruise Packing Checklist</div>
	            			</a>
	            		}
						{this.props.siteConfigData.store.storeCode === 'BJWEB' &&

                             <a href={this.getTravelHotelLink()} target="_blank" rel="noopener noreferrer" class="wth2-css_nav_link wth2-ui-btn box_bcss f bj_btn" id="css_nav_link10" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Add a Hotel Stay")}}>
	            				<i aria-hidden="true" class="fas fa-hotel wth_css_icon"></i>
	            				<div class="wth2-css_nav_invoice">Add a Hotel Stay</div>
	            			</a>
						}
	            	</div>  

					{
						this.siteZendeskID && this.siteZendeskID !== undefined && this.siteZendeskID !== null && this.siteZendeskID !== '' ?
							<div id="makeChangesReservation" class="wth2_css_headdesc">To make any changes to your reservation please chat with us now or call us at 
								<a id="adminPhoneNumberToCall" href={`tel:${this.state.showPhoneNumber}`} className="wth2-phoneNbrResponsive" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Click-To-Call")}}>
									{this.state.showPhoneNumber}
						   		</a>
								<div id="adminPhoneNumberToCall" className="wth2-phoneNbrDesktop">
									{this.state.showPhoneNumber}
						   		</div>
							</div> 
						: <div id="makeChangesReservation" class="wth2_css_headdesc">To make any changes to your reservation please call us at 
							<a id="adminPhoneNumberToCall" href={`tel:${this.state.showPhoneNumber}`} className="wth2-phoneNbrResponsive" onClick={() => {this.props.CallTracker("Customer Self Service", "Booking Summary", "Click-To-Call")}}>
								{this.state.showPhoneNumber}
							</a>
							<div id="adminPhoneNumberToCall"  className="wth2-phoneNbrDesktop">
								{this.state.showPhoneNumber}
							</div>
						</div>
					}
					{ 
						this.getSitePropertyValue('CSS_UPLIFT_ENABLED') === 'Y' && 
						this.state.updateBooking.bookingSummary.charges.remainingBalance > 0 && 

						(
							(	this.state.updateBooking.bookingSummary.charges.remainingBalance>=150 &&  
								this.state.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments!==0 && 
								this.state.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments >=150
							) 
							|| 
							(	this.state.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && 
								this.state.updateBooking.insuranceQuote.priceAmount >=150
							)
						) && 

						this.state.updateBooking.bookingSummary.charges.remainingBalance<=15000 && 
						this.state.updateBooking.bookingSummary.charges.scheduledPayment === undefined &&

						<div id="flexPayMessage" class="wth2_css_headdesc">You may be eligible to split up your final payment into easy monthly installments with Flex Pay.</div>
					}
	            	{this.getStoreAttValue("HLP")!==''&&this.getStoreAttValue("HLP")!==null &&
	            		<div id="css_faqContainer" className="wth2-cssLogin_cssFAQcontainer"><h2 id="wth2-cssLogin_cssFAQtitle" className="wth2-cssLogin_faqTitle">Looking for Answers? Visit our <a href={this.getStoreAttValue("HLP")} id="cssHelpCenterButton" className="wth2-cssLogin_helpLink" target="_blank" rel="noopener noreferrer" onClick={() => {this.props.CallTracker('BCSS Login', 'Help Center Home', '')}}>Help Center</a><br />or click on one of the categories below.</h2><div id="faqButtonContainerWrapper"><FaqButtonService siteConfigData={this.siteConfigData}></FaqButtonService></div></div>
	        		}
	            	
            </div>
        );
    }
   
}

export default SummarySwap;
